module.exports = __webpack_public_path__ + "static/kiosk-9485ded8c2334cf7ed7f157f1e9f8fef.jpg";